import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionTrackerService {
  private taskStartTime: number | null = null;

  constructor() { }
  startTracking(): void {
    this.taskStartTime = Date.now();
  }
  getSessionDuration(): number | null {
    if (!this.taskStartTime) return null;

    const duration = Date.now() - this.taskStartTime; // in milliseconds
    this.taskStartTime = null; // Reset after reading
    return duration;
  }
}